import { scan } from "@pdfking/rfunc"
import { settings_get } from "@pdfking/workflow/state/settings"
import virtual from "@pdfking/workflow/vue/3/virtual"
import serialize_error from "../utils/serialize_error"
import user from "./user"

export default virtual({
  computed: {
    user() {
      return user
    },
  },
  data: () => {
    return {
      AJAX_COUNTER: 0,
      AJAX_REQUEST_CACHE: {},
      IS_SUBMITTED: false,

      LAST_FOCUS: null,
      request_id: null,
    }
  },
  methods: {
    track_error(error, error_type) {
      this.track_event(`${error}`, error_type)
      serialize_error(error)
    },
    track_event(...args) {
      scan(func => func(...args), settings_get("event_handlers"))
    },
  },
})
